module.exports = __webpack_public_path__ + "img/104.40aa23f6.jpg";